import { LinkOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import LinkOrSpan from "../LinkOrSpan/LinkOrSpan";
import styles from "./CrossReference.module.scss";

export default function CrossReference({
  to,
  secondaryTo,
  children,
}: {
  to: string;
  secondaryTo?: string;
  children: ReactNode;
}) {
  return (
    <span className={styles.CrossReference}>
      <LinkOrSpan
        to={secondaryTo}
        className={styles.label}
      >
        {children}
      </LinkOrSpan>
      <Link
        className={`${styles.reference} ${styles.child}`}
        to={to}
      >
        <LinkOutlined />
      </Link>
    </span>
  );
}
